/**
 * Preorder Wolf inserts .pnda-delivery-info on the ATC button parent (breaks wish-list row).
 * Move it into .product-preorder-notice above "Ολοκλήρωσε το Look".
 */
(function () {
  const SLOT_SELECTOR = '.product-preorder-notice';
  const NOTICE_CLASS = 'pnda-delivery-info';

  function getProductFormRoot() {
    return document.querySelector('.shopify-section--main-product product-form');
  }

  function relocatePreorderNotice() {
    const root = getProductFormRoot();
    if (!root) {
      return;
    }

    const slot = root.querySelector(SLOT_SELECTOR);
    if (!slot) {
      return;
    }

    root.querySelectorAll(`.${NOTICE_CLASS}`).forEach((notice) => {
      if (notice.parentElement !== slot) {
        slot.appendChild(notice);
      }
    });
  }

  function init() {
    const root = getProductFormRoot();
    if (!root || root.dataset.preorderRelocateInit === 'true') {
      relocatePreorderNotice();
      return;
    }

    root.dataset.preorderRelocateInit = 'true';

    const observer = new MutationObserver(() => {
      relocatePreorderNotice();
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    const form = root.querySelector('form');
    form?.addEventListener('variant:change', () => {
      requestAnimationFrame(relocatePreorderNotice);
    });

    document.addEventListener('click', () => {
      requestAnimationFrame(relocatePreorderNotice);
    }, { capture: true, passive: true });

    relocatePreorderNotice();
    [300, 800, 1500, 3000].forEach((delay) => {
      setTimeout(relocatePreorderNotice, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
